<div (click)="cta()" title="{{ 'BUTTON.FILTER' | translate }}">
    {{ "BUTTON.FILTER" | translate }}&nbsp;
    <aa-icon-circle [ngClass]="(filterStatus | async) ? 'notif': 'grey'"
                    [faIcon]="'fas fa-filter'">
    </aa-icon-circle>
</div>
